import { defineMessages } from 'react-intl'

export const networkAPMessages = defineMessages({
  wlansSSID: {
    id: 'networkAPMessages.wlansSSID',
    description: 'Title text for WLAN SSID',
    defaultMessage: 'SSID',
  },
  wlansAccessPoints: {
    id: 'networkAPMessages.wlansAccessPoints',
    description: 'Title text for WLAN Access Points',
    defaultMessage: 'Access Points',
  },
  wlansVLANId: {
    id: 'networkAPMessages.wlansVLANId',
    description: 'Title text for WLAN VLAN ID',
    defaultMessage: 'VLAN ID',
  },
  wlansBands: {
    id: 'networkAPMessages.wlansBands',
    description: 'Title text for WLAN Bands',
    defaultMessage: 'Bands',
  },
  wlansSecurity: {
    id: 'networkAPMessages.wlansSecurity',
    description: 'Title text for WLAN Security',
    defaultMessage: 'Security',
  },
  wlansGuest: {
    id: 'networkAPMessages.wlansGuest',
    description: 'Title text for WLAN Guest Enabled',
    defaultMessage: 'Guest Portal',
  },
  titleDelete: {
    id: 'networkAPMessages.titleDelete',
    description: 'Title text for AP Delete',
    defaultMessage: 'Delete AP',
  },
  confirmDeleteMessage: {
    id: 'networkAPMessages.confirmDeleteMessage',
    description: 'Title text for AP Delete',
    defaultMessage: 'Yes, Delete',
  },
})
